<template>
    <div>
        <ejs-grid ref="productGrid" :dataSource="products" :allowPaging="true" :allowSorting='true' :sortSettings='sortOptions' :pageSettings='pageSettings' 
                                    :allowExcelExport='true' :allowReordering='true' :allowResizing='true'>
            <e-columns>
                <e-column field='name' headerText='Produit'  width=20></e-column>
                <e-column field='reference' headerText='Référence' width=20></e-column>
                <e-column field='supplierNames' headerText='Fournisseur' width=20></e-column>
                <e-column field='commands' headerText='' textAlign="center" width=20  :commands="commands"></e-column>
            </e-columns>
        </ejs-grid>

        <!-- modal de suppression d'un produit -->
        <modal :show.sync="deleteModal" headerClasses="justify-content-center">
            <h4 slot="header">{{productName}}</h4>
            <h4 class="text-center mt-0">
                Etes vous sûre de vouloir le <br>
                supprimer?<br>
                (Cette action est définitive et <br>
                irréversible)
            </h4>
            <div class="row justify-content-around">
                <button class="col-5 btn btn-sm btn-primary radius" @click="backToList()">Annuler</button>
                <button class="col-5 btn btn-sm btn-suppr radius" @click="deleteProduct()">Supprimer</button>
            </div>
        </modal>
    </div>
    
</template>

<script>
import { Modal } from 'src/components'
import { GridPlugin, Page, Sort, Search, ExcelExport, Reorder, Resize, CommandColumn} from "@syncfusion/ej2-vue-grids";


    export default {
        name: 'ProductList',
        components: {
            Modal
        },
        data(){ 
            return {
                productId: '',

                productName: '',
                
                deleteModal: false,

                products: [],
 
                suppliersNames: [],

                pageSettings: { pageSizes: [10, 20, 50] , pageSize: 10  },

                sortOptions: { columns: [{ field: 'name', direction: 'Ascending' }] },
                
                commands: [
                    { buttonOption: { cssClass: 'e-flat', iconCss: 'fa fa-edit', click: this.editButton} },
                    { buttonOption: { cssClass: 'e-flat', iconCss: 'fa fa-trash-alt', click: this.deleteButton} },
                ],
            }
        },
        provide: {
            grid: [Page, Sort, Search, ExcelExport, Reorder, Resize, CommandColumn]
        },
        beforeDestroy(){
            // Sauvegarde la configuration du tableau dans le localStorage
            var grid = this.$refs.productGrid.ej2Instances;
            localStorage.setItem('productGrid', (grid.getPersistData()));
        },
        mounted() {
            // Remplir "products" avec un appel GET Axios
            this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/product/list`).then((response) => {
                this.products = response.data
                this.products.forEach( product => {
                    var supplierList = ''
                    product.suppliers.forEach(supplier => {
                        supplierList += supplier.name +', '
                    })
                    supplierList = supplierList.slice(0, -2)

                    product.supplierNames = supplierList
                })
            })
            this.getPersistentSettings('productGrid')
        },
        methods: {

            backToList() {
                this.deleteModal = false
            },

            getPersistentSettings(ref){
                if(localStorage.getItem(ref) !== null){
                    var grid = this.$refs[ref].ej2Instances;

                    var model = (localStorage.getItem(ref))
                    var modelParsed = JSON.parse(model);

                    var newColumns= [];
                    var cookieColumns = modelParsed.columns;
                    var actualColumns = grid.columns;

                    cookieColumns.forEach(cookieColumn => {
                    actualColumns.forEach(actualColumn => {
                        if(actualColumn.index == cookieColumn.index){
                        actualColumn.visible = cookieColumn.visible;
                        newColumns.push(actualColumn)
                        }
                    })
                    })

                    grid.columns = newColumns;
                    grid.sortSettings = modelParsed.sortSettings;
                    grid.pageSettings.currentPage = modelParsed.pageSettings.currentPage
                }
            },

            editButton(args){
                var rowEle = $(args.target).parents('.e-row')
                var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
                this.$refs.productGrid.selectRow(rowIndex)
                var rowData = this.$refs.productGrid.getSelectedRecords()[0]
                this.$router.push({ name: 'product form', params: { id: rowData.id }})
            },

            deleteButton(args){
                var rowEle = $(args.target).parents('.e-row')
                var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
                this.$refs.productGrid.selectRow(rowIndex)
                var rowData = this.$refs.productGrid.getSelectedRecords()[0]
                this.productId = rowData.id
                this.productName = rowData.name
                this.deleteModal = true
                
            },

            deleteProduct(){   
                const index = this.products.findIndex(product => product.id === this.productId)
                this.axios.post(process.env.VUE_APP_API_BASE_URL + `product/delete/` + this.productId).then((response => {
                    this.$notify({ message: 'Le produit à bien été supprimé', type: "success", verticalAlign: "bottom" })
                    this.products.splice(index,1)
                    this.$refs.productGrid.refresh()
                })).catch( error => {
                    this.$notify({ message: 'Le produit est utilisé dans une fiche et ne peut pas être supprimé', type: "danger", verticalAlign: "bottom" })   
                })
                this.deleteModal = false 
                
                   
            },

            // Permet de faire une recherche dans le tableau
            search: function() {
                let searchText = document.getElementsByClassName('MySearch')[0].value;
                this.$refs.productGrid.search(searchText);
            },

            excelExport: function() {
                
                this.$refs.productGrid.excelExport();
                
            }
        },
    }
</script>

<style>
    .icon {
        cursor: pointer;
        width: 2rem;
        height: 2rem;
        border: none;
        background-color: inherit;
    }
</style>